// extracted by mini-css-extract-plugin
export default {"imageContainer":"UploadProfilePicture_imageContainer__BTuzP","uploadWrapper":"UploadProfilePicture_uploadWrapper__OSlqU","uploadText":"UploadProfilePicture_uploadText__7YgJS"};